var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countrys-Cloud",staticStyle:{"height":"30vh","width":"100%","margin":"0"}},[_c('svg',{attrs:{"id":"countrysCloud","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }